function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import generateCell from './cell.js';
import getCellStyleProperties from './helpers/getCellStyleProperties.js';
import getOpeningTagMarkup from '../../../xml/getOpeningTagMarkup.js';
import getClosingTagMarkup from '../../../xml/getClosingTagMarkup.js';
import isCellObject from '../../helpers/isCellObject.js';
export default function generateRow(row, rowIndex, _ref) {
  var findOrCreateCellStyle = _ref.findOrCreateCellStyle,
    findOrCreateSharedString = _ref.findOrCreateSharedString,
    hasDefaultFont = _ref.hasDefaultFont,
    dateFormat = _ref.dateFormat,
    features = _ref.features;
  // To ensure the row number starts as in Excel.
  var rowNumber = rowIndex + 1;
  var rowHeight;
  var rowCells = row.map(function (cell, columnIndex) {
    if (cell === undefined || cell === null) {
      return '';
    }
    var cellObject = isCellObject(cell) ? cell : {
      value: cell
    };
    var cellStyleProperties = getCellStyleProperties(cellObject, features);
    var height = cellObject.height;
    var type = cellObject.type,
      value = cellObject.value,
      format = cellObject.format;
    if (isEmpty(value)) {
      value = null;
    } else {
      // Get cell value type.
      if (type === undefined) {
        type = detectValueType(value);
        if (type === undefined) {
          // The default cell value type is `String`.
          type = String;
          value = String(value);
        }
      }
    }

    // Validate `format` property.
    if (format) {
      if (type !== Date && type !== Number && type !== String && type !== 'Formula') {
        throw new Error("`format` \"".concat(format, "\" was specified on a cell of type `").concat(type, "`. `format` could only be specified on a cell of type `Date`, `Number`, `String` or `\"Formula\"`."));
      }
      if (type === String && format !== '@') {
        throw new Error("`format` \"".concat(format, "\" was specified on a cell of type `String`. The only supported `format` for a cell of type `String` is \"@\"."));
      }
    } else {
      if (type === Date) {
        format = dateFormat;
      }
    }
    var hasFormat = Boolean(format);
    var hasCellStyle = Boolean(cellStyleProperties);
    var cellStyleId;
    if (hasDefaultFont || hasFormat || hasCellStyle) {
      cellStyleId = findOrCreateCellStyle(_objectSpread({
        format: format
      }, cellStyleProperties));
    }
    if (height) {
      if (rowHeight === undefined || rowHeight < height) {
        rowHeight = height;
      }
    }
    return generateCell(rowNumber, columnIndex, value, type, cellStyleId, findOrCreateSharedString);
  }).join('');
  var rowAttributes = {
    r: rowNumber
  };
  if (rowHeight) {
    rowAttributes.ht = rowHeight;
    rowAttributes.customHeight = 1;
  }
  return getOpeningTagMarkup('row', rowAttributes) + rowCells + getClosingTagMarkup('row');
}
function isEmpty(value) {
  return value === undefined || value === null || value === '';
}
function detectValueType(value) {
  switch (_typeof(value)) {
    case 'string':
      return String;
    case 'number':
      return Number;
    case 'boolean':
      return Boolean;
    default:
      if (value instanceof Date) {
        return Date;
      }
  }
}
//# sourceMappingURL=row.js.map